module.exports = __webpack_public_path__ + "img/Front.02ae2888.jpg";